import type * as Types from '../../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import { ShFieldsFragmentDoc } from '../../../graphql/gql-fragments/shareholder.graphql';
import { IdentityFieldsFragmentDoc } from '../../../graphql/gql-fragments/identity.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlShareholderOverviewQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  date?: Types.InputMaybe<Types.Scalars['Date']['input']>;
}>;


export type GqlShareholderOverviewQuery = { company: { id: string, name: string, organizationNumber: string }, shareState: { totalNumberOfShares: number, isValid: boolean, ownerStates: Array<{ shareholderId: string, numberOfShares: number, shareholder: { id: string, identityId: string, companyId: string, ownerCompanyId?: string | null, createdAt: string, updatedAt: string, identity: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string } }, ranges: Array<{ start: number, end: number, transactionDate: string, shareClass: { name: string, voteWeight: string } }> }> } };

export type GqlDeleteShareholderMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  id: Types.Scalars['ID']['input'];
}>;


export type GqlDeleteShareholderMutation = { deleteShareholder: { id: string } };


export const ShareholderOverviewDocument = gql`
    query ShareholderOverview($companyId: ID!, $date: Date) {
  company(id: $companyId) {
    id
    name
    organizationNumber
  }
  shareState(companyId: $companyId, input: {untilDate: $date, keepFormer: true}) {
    totalNumberOfShares
    isValid
    ownerStates {
      shareholderId
      numberOfShares
      shareholder {
        ...ShFields
        identity {
          ...IdentityFields
        }
      }
      ranges {
        start
        end
        transactionDate
        shareClass {
          name
          voteWeight
        }
      }
    }
  }
}
    ${ShFieldsFragmentDoc}
${IdentityFieldsFragmentDoc}`;

/**
 * __useShareholderOverviewQuery__
 *
 * To run a query within a React component, call `useShareholderOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareholderOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareholderOverviewQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useShareholderOverviewQuery(baseOptions: Apollo.QueryHookOptions<GqlShareholderOverviewQuery, GqlShareholderOverviewQueryVariables> & ({ variables: GqlShareholderOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlShareholderOverviewQuery, GqlShareholderOverviewQueryVariables>(ShareholderOverviewDocument, options);
      }
export function useShareholderOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlShareholderOverviewQuery, GqlShareholderOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlShareholderOverviewQuery, GqlShareholderOverviewQueryVariables>(ShareholderOverviewDocument, options);
        }
export function useShareholderOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlShareholderOverviewQuery, GqlShareholderOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlShareholderOverviewQuery, GqlShareholderOverviewQueryVariables>(ShareholderOverviewDocument, options);
        }
export type ShareholderOverviewQueryHookResult = ReturnType<typeof useShareholderOverviewQuery>;
export type ShareholderOverviewLazyQueryHookResult = ReturnType<typeof useShareholderOverviewLazyQuery>;
export type ShareholderOverviewSuspenseQueryHookResult = ReturnType<typeof useShareholderOverviewSuspenseQuery>;
export type ShareholderOverviewQueryResult = Apollo.QueryResult<GqlShareholderOverviewQuery, GqlShareholderOverviewQueryVariables>;
export const DeleteShareholderDocument = gql`
    mutation DeleteShareholder($companyId: ID!, $id: ID!) {
  deleteShareholder(companyId: $companyId, id: $id) {
    id
  }
}
    `;
export type GqlDeleteShareholderMutationFn = Apollo.MutationFunction<GqlDeleteShareholderMutation, GqlDeleteShareholderMutationVariables>;

/**
 * __useDeleteShareholderMutation__
 *
 * To run a mutation, you first call `useDeleteShareholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShareholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShareholderMutation, { data, loading, error }] = useDeleteShareholderMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteShareholderMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteShareholderMutation, GqlDeleteShareholderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteShareholderMutation, GqlDeleteShareholderMutationVariables>(DeleteShareholderDocument, options);
      }
export type DeleteShareholderMutationHookResult = ReturnType<typeof useDeleteShareholderMutation>;
export type DeleteShareholderMutationResult = Apollo.MutationResult<GqlDeleteShareholderMutation>;
export type DeleteShareholderMutationOptions = Apollo.BaseMutationOptions<GqlDeleteShareholderMutation, GqlDeleteShareholderMutationVariables>;